export const ellipsisStyle = (maxWidth=120) => {
	return {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		maxWidth: `${maxWidth}px`,
		display: "inline-block",
		verticalAlign: "middle"
	}
}
export const ellipsisLined = ({lines=2, maxWidth=120}) => {
	return {
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: lines,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		maxWidth: `${maxWidth}px`
	}
}